import { fadeInit, fadeAnim } from './fade';
import { lineInit, lineAnim } from './line';
import { titleInit, titleAnim } from './title';

export function footerInit(el) {
  const container = el instanceof HTMLElement ? el : el.node;
  const lines = [...container.querySelectorAll('[data-item="line"]')];
  const title = container.querySelector('[data-item="title"] h3');
  const content = [...container.querySelectorAll('[data-item="content"]')];
  const legal = container.querySelector('[data-item="legal"]');
  const eyelet = container.querySelector('[data-item="eyelet"]');

  lines.forEach(ele => lineInit(ele));
  titleInit(title);
  content.forEach(ele => fadeInit(ele, 50));
  fadeInit(legal, 50);
  fadeInit(eyelet, 50);
}

export function footerAnim(el) {
  const container = el instanceof HTMLElement ? el : el.node;
  const lines = [...container.querySelectorAll('[data-item="line"]')];
  const title = container.querySelector('[data-item="title"] h3');
  const content = [...container.querySelectorAll('[data-item="content"]')];
  const legal = container.querySelector('[data-item="legal"]');
  const eyelet = container.querySelector('[data-item="eyelet"]');

  fadeAnim(eyelet);
  lineAnim(lines[0], 200);
  titleAnim(title, 400);
  lineAnim(lines[1], 600);
  lineAnim(lines[2], 900);
  content.forEach(ele => fadeAnim(ele, 800));
  lineAnim(lines[3], 900);
  lineAnim(lines[4], 1200);
  fadeAnim(legal, 1000);
}
